<template>
  <div class="header-popup" :class="{'header-popup--empty': isEmptyPopup}" v-if="isPopupVisible">
    <div v-if="isEmptyPopup" class="header-popup__empty">
      <img :src="emptyPopupData.src" alt="icon" class="header-popup__icon" />
      <h3 class="header-popup__title">{{ emptyPopupData.title }}</h3>
      <span class="header-popup__text">{{ emptyPopupData.text }}</span>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  name: 'HeaderPopup',
  props: {
    isPopupVisible: {
      type: Boolean,
      default: false
    },
    isEmptyPopup: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    emptyPopupData () {
      let data = {}

      switch (this.type) {
        case 'cart':
          data.src = '/img/svgo/empty-cart-1.svg'
          data.title = this.$t('cart_empty_title')
          data.text = this.$t('cart_empty_text')
          break
        case 'comparison':
          data.src = '/img/svgo/empty-comparison-1.svg'
          data.title = this.$t('product_comparison_empty')
          data.text = this.$t('add_products_you_want')
          break
        case 'wishlist':
          data.src = '/img/svgo/empty-wishlist-1.svg'
          data.title = this.$t('wishlist_empty_title')
          data.text = this.$t('wishlist_empty_text')
          break
      }

      return data
    }
  }
}
</script>

<style scoped lang="sass">
.header-popup
  display: block
  position: absolute
  top: 100%
  right: -15px
  box-shadow: 0 4px 7px rgba(181, 181, 181, 0.25)
  border-radius: 0 0 3px 3px
  background-color: #ffffff
  width: 100vw
  z-index: 3
  border-top: 1px solid $nd-border-color

  +mmin($between-phone-tablet)
    top: 100%
    width: 420px
    right: 0

.header-popup--empty
  padding: 30px 20px

.header-popup.small-cart
  width: 420px

  +mmax($between-phone-tablet)
    display: none!important

.header-popup__empty
  display: flex
  flex-flow: column
  justify-content: center
  align-items: center

.header-popup__title
  font-size: 24px
  font-weight: 500
  margin: 30px 0 0

.header-popup__text
  font-size: 16px
  font-weight: 400
  margin: 10px 0 0
  color: $placeholder-color
  max-width: 250px
  text-align: center

</style>
